import React from 'react'
import PropTypes from 'prop-types'
import { Icon } from '../styles'

/**
 *
 * @param {number} size size icon
 * @param {string} color color hexadecimal
 * @returns {React.Component}
 */
const IcCancel = ({ size, color }) => {
  return (
    <Icon
      className="IcCancel material-icons tw-block tw-flex tw-items-center tw-justify-center"
      size={size}
      color={color}
    >
      cancel
    </Icon>
  )
}

IcCancel.propTypes = {
  size: PropTypes.number.isRequired,
  color: PropTypes.string.isRequired
}

export default IcCancel
